import { BackendServiceUrl, BaseService } from './BaseService';
import { UpdatePreferencesRequest, UserPreferences } from '../models/UserPreferences';

export class PreferencesService extends BaseService {
    constructor(accessToken: string, baseServiceUrl: string = BackendServiceUrl) {
        super(accessToken, baseServiceUrl);
    }

    public async getPreferencesAsync(): Promise<UserPreferences> {
        return await this.getResponseAsync<UserPreferences>({
            commandPath: 'preferences/me',
            method: 'GET',
        });
    }

    public async updatePreferencesAsync(request: UpdatePreferencesRequest): Promise<UserPreferences> {
        return await this.getResponseAsync<UserPreferences>({
            commandPath: 'preferences/me',
            method: 'PUT',
            body: request,
        });
    }

    public async dismissRestyleNudgeAsync(): Promise<UserPreferences> {
        return await this.getResponseAsync<UserPreferences>({
            commandPath: 'preferences/me/dismiss-restyle-nudge',
            method: 'PUT',
        });
    }
}
